import { Component } from 'preact';
import PropTypes from 'prop-types';

export class ConfirmationModal extends Component {
  render() {
    const { onClose, onConfirm, loading } = this.props;

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <button
            type="button"
            className="modal-close-button"
            onClick={loading ? null : onClose}
            aria-label="Fechar modal"
          >
            <i className="icon icon-close" />
          </button>

          <h2 className="modal-title">Importante</h2>
          <p className="modal-message">
            Lembre-se de que o test drive ainda precisa ser confirmado.
            <br />
            <br />
            Um consultor da concessionária entrará em contato em breve para
            confirmar o agendamento.
          </p>
          <button
            className="modal-button"
            type="button"
            onClick={loading ? null : onConfirm}
          >
            {loading ? 'Enviando' : 'Ok, estou ciente!'}
            {loading ? (
              <div className="ml-2 spinner-border" role="status" />
            ) : null}
          </button>
        </div>
      </div>
    );
  }
}

ConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
